export default __webpack_public_path__ + "static/media/.env.edf7e0c0.bin";